import { Route, Location } from "react-router-dom";
import SlideRoutes from "react-slide-routes";
import React, { ComponentType } from "react";
import { ConfigType } from "../context/AppContext";
import StandardLayout from "../components/Layout/StandardLayout";
import ListingPage from "../components/ListingPage";
import { OnboardingNavBars } from "../components/OnboardingModules";
import { RecoEngineProvider } from "../features/RecoEngine";
import { generateOnboardingPathAndKey } from "../utils/CommonFunctions";

export type ImportedComponentType = ComponentType<any>;

class RouteCreationService {
  static createRoutes(configs: Array<ConfigType>, useIncrementalPath = false) {
    return configs.map((config) =>
      config.components.map(({ Component }, j) => {
        const { path, key } = generateOnboardingPathAndKey(
          Component,
          j,
          useIncrementalPath,
          config.name
        );
        return (
          <Route
            key={key}
            path={path}
            element={
              <RecoEngineProvider>
                <Component />
              </RecoEngineProvider>
            } // TypeScript should now know Component is a valid React component
          />
        );
      })
    );
  }

  static createOnboardingRoutes(
    configs: Array<ConfigType>,
    location: Location,
    useIncrementalPath = false
  ) {
    const routes: React.ReactNode[] = [];
    const whiteList = new Set();

    const buttonStyle = configs?.[0]?.buttonStyle ?? "";

    configs.forEach((config) => {
      config.components.forEach(({ Component }, j) => {
        const { path, key } = generateOnboardingPathAndKey(
          Component,
          j,
          useIncrementalPath,
          config.name
        );

        whiteList.add(`/${path}`); // Adding the path to the whitelist

        routes.push(<Route key={key} path={path} element={<Component />} />);
      });
    });

    const currentPath = location.pathname;
    const shouldShowOnboardingNavBars = whiteList.has(currentPath);

    return (
      <div>
        {shouldShowOnboardingNavBars ? (
          <OnboardingNavBars buttonStyle={buttonStyle}>
            <SlideRoutes timing="ease-in-out" duration={300}>
              {routes}
            </SlideRoutes>
          </OnboardingNavBars>
        ) : null}
      </div>
    );
  }

  static createListingPageRoute() {
    return (
      <>
        <Route
          path={`${window.GLOBAL_PATH}:ROUTE_ID`}
          element={
            <StandardLayout>
              <ListingPage />
            </StandardLayout>
          }
        />
        <Route
          path={window.GLOBAL_PATH}
          element={
            <StandardLayout>
              <ListingPage />
            </StandardLayout>
          }
        />
      </>
    );
  }
}

export default RouteCreationService;
